<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Markvision Enterprise">
     Markvision Enterprise
    </a>
   </p>
   <p class="toc-1-style">
    <a href="change-history.html#change-history_es" title="Historial de cambios">
     Historial de cambios
    </a>
   </p>
   <div id="divd0e8">
   </div>
   <p class="toc-1-style">
    <a href="overview-chapter.html#overview-chapter_es" title="Descripci&oacute;n general">
     Descripci&oacute;n general
    </a>
   </p>
   <div id="divd0e260">
    <p class="toc-2-style">
     <a href="overview-chapter.html#overview-markvision-enterprise_es" title="Descripci&oacute;n de Markvision Enterprise">
      Descripci&oacute;n de Markvision Enterprise
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="getting-started-chapter.html#getting-started-chapter_es" title="Introducci&oacute;n">
     Introducci&oacute;n
    </a>
   </p>
   <div id="divd0e289">
    <p class="toc-2-style">
     <a href="best-practices-topic.html#best-practices_es" title="Mejores pr&aacute;cticas">
      Mejores pr&aacute;cticas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="system-requirements-topic.html#system-requirements_es" title="Requisitos del sistema">
      Requisitos del sistema
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-languages-topic.html#supported-languages_es" title="Idiomas compatibles">
      Idiomas compatibles
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-printer-models-topic.html#supported-printer-models_es" title="Modelos de impresora admitidos">
      Modelos de impresora admitidos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-database-topic.html#setting-up-database_es" title="Configuraci&oacute;n de la base de datos">
      Configuraci&oacute;n de la base de datos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-mve-run-as-user-topic.html#d0e1132" title="Configuraci&oacute;n para ejecutar como usuario">
      Configuraci&oacute;n para ejecutar como usuario
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-markvision-topic.html#installing-markvision_es" title="Instalaci&oacute;n de MVE">
      Instalaci&oacute;n de MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-mve-silently-topic.html#installing-mve-silently_es" title="Instalaci&oacute;n silenciosa de MVE">
      Instalaci&oacute;n silenciosa de MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-mve-topic.html#accessing-mve_es" title="Acceso a MVE">
      Acceso a MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-topic.html#changing-language_es" title="Cambio de idioma">
      Cambio de idioma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-your-password-topic.html#changing-your-password_es" title="Cambio de la contrase&ntilde;a">
      Cambio de la contrase&ntilde;a
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-application-chapter.html#maintaining-application-chapter_es" title="Mantenimiento de la aplicaci&oacute;n">
     Mantenimiento de la aplicaci&oacute;n
    </a>
   </p>
   <div id="divd0e1715">
    <p class="toc-2-style">
     <a href="upgrading-to-latest-version-topic.html#upgrading-to-latest-version_es" title="Actualizaci&oacute;n a MVE 4.3">
      Actualizaci&oacute;n a MVE 4.3
     </a>
    </p>
    <p class="toc-2-style">
     <a href="backing-up-and-restoring-database-topic.html#backing-up-and-restoring-database_es" title="Copia de seguridad y restauraci&oacute;n de la base de datos">
      Copia de seguridad y restauraci&oacute;n de la base de datos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-installer-settings-topic.html#changing-installer-settings_es" title="Actualizaci&oacute;n de la configuraci&oacute;n del instalador tras la instalaci&oacute;n">
      Actualizaci&oacute;n de la configuraci&oacute;n del instalador tras la instalaci&oacute;n
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-user-access-chapter.html#setting-user-access-chapter_es" title="Configuraci&oacute;n del acceso de usuario">
     Configuraci&oacute;n del acceso de usuario
    </a>
   </p>
   <div id="divd0e1987">
    <p class="toc-2-style">
     <a href="setting-up-user-access-overview-topic.html#setting-up-user-access-overview_es" title="Descripci&oacute;n general">
      Descripci&oacute;n general
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-user-roles-topic.html#understanding-user-roles_es" title="Descripci&oacute;n de las funciones de usuario">
      Descripci&oacute;n de las funciones de usuario
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-users-topic.html#managing-users_es" title="Administraci&oacute;n de usuarios">
      Administraci&oacute;n de usuarios
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-ldap-server-authentication-topic.html#enabling-ldap-server-authentication_es" title="Activaci&oacute;n de la autenticaci&oacute;n del servidor LDAP">
      Activaci&oacute;n de la autenticaci&oacute;n del servidor LDAP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-ldap-server-certificates-topic.html#installing-ldap-server-certificates_es" title="Instalaci&oacute;n de certificados del servidor LDAP">
      Instalaci&oacute;n de certificados del servidor LDAP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-root-ca-certificate-java-truststore-topic.html#adding-root-ca-certificate-java-truststore_es" title="Adici&oacute;n de un certificado CA ra&iacute;z en el almac&eacute;n de confianza de Java">
      Adici&oacute;n de un certificado CA ra&iacute;z en el almac&eacute;n de confianza de Java
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="discovering-devices-chapter.html#discovering-devices-chapter_es" title="B&uacute;squeda de impresoras">
     B&uacute;squeda de impresoras
    </a>
   </p>
   <div id="divd0e2401">
    <p class="toc-2-style">
     <a href="creating-discovery-profile-topic.html#creating-discovery-profile_es" title="Creaci&oacute;n de perfiles de b&uacute;squeda">
      Creaci&oacute;n de perfiles de b&uacute;squeda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-discovery-profiles-topic.html#managing-discovery-profiles_es" title="Administraci&oacute;n de perfiles de b&uacute;squeda">
      Administraci&oacute;n de perfiles de b&uacute;squeda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-discovering-printers-topic.html#sample-scenario-discovering-printers_es" title="Caso de ejemplo: B&uacute;squeda de impresoras">
      Caso de ejemplo: B&uacute;squeda de impresoras
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-dashboard-chapter.html#maintaining-dashboard-chapter_es" title="Administraci&oacute;n del panel de seguridad">
     Administraci&oacute;n del panel de seguridad
    </a>
   </p>
   <div id="divd0e2657">
    <p class="toc-2-style">
     <a href="overview-security-dashboard-topic.html#overview-security-dashboard_es" title="Descripci&oacute;n general">
      Descripci&oacute;n general
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-dashboard-topic.html#accessing-dashboard_es" title="Acceso al panel de seguridad">
      Acceso al panel de seguridad
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-device-security-information-topic.html#managing-device-security-information_es" title="Administraci&oacute;n de Informaci&oacute;n de seguridad del dispositivo">
      Administraci&oacute;n de Informaci&oacute;n de seguridad del dispositivo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-device-conformance-check-topic.html#managing-device-conformance-check_es" title="Administraci&oacute;n de Comprobaci&oacute;n de cumplimiento del dispositivo">
      Administraci&oacute;n de Comprobaci&oacute;n de cumplimiento del dispositivo
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="finding-devices-chapter.html#finding-devices-chapter_es" title="Visualizaci&oacute;n de impresoras">
     Visualizaci&oacute;n de impresoras
    </a>
   </p>
   <div id="divd0e2766">
    <p class="toc-2-style">
     <a href="viewing-printer-list-topic.html#viewing-printer-list_es" title="Visualizaci&oacute;n de la lista de la impresora">
      Visualizaci&oacute;n de la lista de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-device-information-topic.html#viewing-device-information_es" title="Visualizaci&oacute;n de la informaci&oacute;n de la impresora">
      Visualizaci&oacute;n de la informaci&oacute;n de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-data-topic.html#exporting-data_es" title="Exportaci&oacute;n de datos de la impresora">
      Exportaci&oacute;n de datos de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-views-topic.html#managing-views_es" title="Administraci&oacute;n de vistas">
      Administraci&oacute;n de vistas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-printer-listing-view-topic.html#changing-printer-listing-view_es" title="Cambio de la vista de lista de impresoras">
      Cambio de la vista de lista de impresoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="filtering-printers-using-search-bar-topic.html#filtering-printers-using-search-bar_es" title="Filtrado de impresoras mediante la barra de b&uacute;squeda">
      Filtrado de impresoras mediante la barra de b&uacute;squeda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-keywords-topic.html#managing-keywords_es" title="Administraci&oacute;n de palabras clave">
      Administraci&oacute;n de palabras clave
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-device-life-cycle-states-topic.html#d0e3226" title="Utilizaci&oacute;n de las b&uacute;squedas guardadas">
      Utilizaci&oacute;n de las b&uacute;squedas guardadas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-monitor-fleet-topic.html#sample-scenario-monitor-fleet_es" title="Caso de ejemplo: Controlar los niveles de t&oacute;ner de su flota">
      Caso de ejemplo: Controlar los niveles de t&oacute;ner de su flota
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-devices-chapter.html#securing-devices-chapter_es" title="Protecci&oacute;n de las comunicaciones de la impresora">
     Protecci&oacute;n de las comunicaciones de la impresora
    </a>
   </p>
   <div id="divd0e4163">
    <p class="toc-2-style">
     <a href="understanding-security-status-topic.html#understanding-security-status_es" title="Descripci&oacute;n de los estados de seguridad de la impresora">
      Descripci&oacute;n de los estados de seguridad de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-using-default-config-topic.html#securing-printers-using-default-config_es" title="Protecci&oacute;n de impresoras con la configuraci&oacute;n predeterminada">
      Protecci&oacute;n de impresoras con la configuraci&oacute;n predeterminada
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-fac-permissions-topic.html#understanding-fac-permissions_es" title="Descripci&oacute;n de los permisos y controles de acceso a funci&oacute;n">
      Descripci&oacute;n de los permisos y controles de acceso a funci&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-device-security-topic.html#configuring-device-security_es" title="Configuraci&oacute;n de la seguridad de la impresora">
      Configuraci&oacute;n de la seguridad de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printer-communications-on-your-fleet-topic.html#securing-printer-communications-on-your-fleet_es" title="Protecci&oacute;n de las comunicaciones de la impresora en su grupo">
      Protecci&oacute;n de las comunicaciones de la impresora en su grupo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-topic.html#securing-printers_es" title="Otras maneras de proteger sus impresoras">
      Otras maneras de proteger sus impresoras
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-assets-chapter.html#managing-assets-chapter_es" title="Administraci&oacute;n de impresoras">
     Administraci&oacute;n de impresoras
    </a>
   </p>
   <div id="divd0e4527">
    <p class="toc-2-style">
     <a href="restarting-printer-topic.html#restarting-printer_es" title="Reinicio de la impresora">
      Reinicio de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-ews-topic.html#viewing-ews_es" title="Visualizaci&oacute;n de Embedded Web Server de la impresora">
      Visualizaci&oacute;n de Embedded Web Server de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="auditing-devices-topic.html#auditing-devices_es" title="Auditor&iacute;a de impresoras">
      Auditor&iacute;a de impresoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-status-topic.html#updating-printer-status_es" title="Actualizaci&oacute;n del estado de la impresora">
      Actualizaci&oacute;n del estado de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-device-state-topic.html#setting-device-state_es" title="Configuraci&oacute;n del estado de la impresora">
      Configuraci&oacute;n del estado de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-configurations-to-devices-topic.html#assigning-configurations-to-devices_es" title="Asignaci&oacute;n de configuraciones a impresoras">
      Asignaci&oacute;n de configuraciones a impresoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unassigning-configurations-topic.html#unassigning-configurations_es" title="Desasignaci&oacute;n de configuraciones">
      Desasignaci&oacute;n de configuraciones
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enforcing-configurations-topic.html#enforcing-configurations_es" title="Aplicaci&oacute;n de configuraciones">
      Aplicaci&oacute;n de configuraciones
     </a>
    </p>
    <p class="toc-2-style">
     <a href="checking-device-conformance-topic.html#checking-device-conformance_es" title="Comprobaci&oacute;n de la conformidad de la impresora con una configuraci&oacute;n">
      Comprobaci&oacute;n de la conformidad de la impresora con una configuraci&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="deploying-files-to-printers-topic.html#deploying-files-to-printers_es" title="Implementaci&oacute;n de archivos en impresoras">
      Implementaci&oacute;n de archivos en impresoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-firmware-topic.html#updating-printer-firmware_es" title="Actualizaci&oacute;n del firmware de la impresora">
      Actualizaci&oacute;n del firmware de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="uninstalling-applications-from-devices-topic.html#uninstalling-applications-from-devices_es" title="Desinstalaci&oacute;n de aplicaciones de las impresoras">
      Desinstalaci&oacute;n de aplicaciones de las impresoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-events-to-device-topic.html#assigning-events-to-device_es" title="Asignaci&oacute;n de eventos a impresoras">
      Asignaci&oacute;n de eventos a impresoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-keyword-topic.html#assigning-keyword_es" title="Asignar palabras clave a impresoras">
      Asignar palabras clave a impresoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="entering-credentials-secured-printers-topic.html#entering-credentials-secured-printers_es" title="Introducci&oacute;n de las credenciales para impresoras protegidas">
      Introducci&oacute;n de las credenciales para impresoras protegidas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-certificates-manually-topic.html#configuring-printer-certificates-manually_es" title="Configuraci&oacute;n de los certificados de la impresora predeterminada de forma manual">
      Configuraci&oacute;n de los certificados de la impresora predeterminada de forma manual
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-printers-topic.html#removing-printers_es" title="Eliminaci&oacute;n de impresoras">
      Eliminaci&oacute;n de impresoras
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-configurations-chapter.html#managing-configurations-chapter_es" title="Administraci&oacute;n de configuraciones">
     Administraci&oacute;n de configuraciones
    </a>
   </p>
   <div id="divd0e5133">
    <p class="toc-2-style">
     <a href="managing-configurations-overview-topic.html#managing-configurations-overview_es" title="Descripci&oacute;n general">
      Descripci&oacute;n general
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-topic.html#creating-configuration_es" title="Creaci&oacute;n de una configuraci&oacute;n">
      Creaci&oacute;n de una configuraci&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-from-printer-topic.html#creating-configuration-from-printer_es" title="Creaci&oacute;n de una configuraci&oacute;n desde una impresora">
      Creaci&oacute;n de una configuraci&oacute;n desde una impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-cloning-configurations-topic.html#sample-scenario-cloning-configurations_es" title="Caso de ejemplo: clonaci&oacute;n de una configuraci&oacute;n">
      Caso de ejemplo: clonaci&oacute;n de una configuraci&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-advanced-security-component-topic.html#creating-advanced-security-component_es" title="Creaci&oacute;n de un componente de seguridad avanzada desde una impresora">
      Creaci&oacute;n de un componente de seguridad avanzada desde una impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-printable-version-topic.html#generating-printable-version_es" title="Generaci&oacute;n de una versi&oacute;n para imprimir de la configuraci&oacute;n">
      Generaci&oacute;n de una versi&oacute;n para imprimir de la configuraci&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-dynamic-settings-topic.html#understanding-dynamic-settings_es" title="Descripci&oacute;n de los ajustes din&aacute;micos">
      Descripci&oacute;n de los ajustes din&aacute;micos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-variable-settings-topic.html#understanding-variable-settings_es" title="Descripci&oacute;n de los ajustes de variables">
      Descripci&oacute;n de los ajustes de variables
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-color-permissions-topic.html#configuring-color-permissions_es" title="Configuraci&oacute;n de los permisos de impresi&oacute;n en color">
      Configuraci&oacute;n de los permisos de impresi&oacute;n en color
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-applications-package-topic.html#creating-applications-package_es" title="Creaci&oacute;n de un paquete de aplicaciones">
      Creaci&oacute;n de un paquete de aplicaciones
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-exporting-configuration-file-topic.html#importing-exporting-configuration-file_es" title="Importaci&oacute;n o exportaci&oacute;n de una configuraci&oacute;n">
      Importaci&oacute;n o exportaci&oacute;n de una configuraci&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-files-to-resource-library-topic.html#importing-files-to-resource-library_es" title="Importaci&oacute;n de archivos a la biblioteca de recursos">
      Importaci&oacute;n de archivos a la biblioteca de recursos
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-cert-auto-manage-chapter.html#setting-up-cert-auto-manage-chapter_es" title="Administraci&oacute;n de certificados">
     Administraci&oacute;n de certificados
    </a>
   </p>
   <div id="divd0e5644">
    <p class="toc-2-style">
     <a href="setting-up-MVE-manage-certificates-automatically-group.html#d0e5647" title="Configuraci&oacute;n de MVE para gestionar certificados de forma autom&aacute;tica">
      Configuraci&oacute;n de MVE para gestionar certificados de forma autom&aacute;tica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-SCEP-group.html#d0e5973" title="Administraci&oacute;n de certificados mediante la autoridad certificadora de Microsoft a trav&eacute;s de SCEP">
      Administraci&oacute;n de certificados mediante la autoridad certificadora de Microsoft a trav&eacute;s de SCEP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-MSCEWS-group.html#d0e6695" title="Administraci&oacute;n de certificados mediante la autoridad certificadora de Microsoft a trav&eacute;s de MSCEWS">
      Administraci&oacute;n de certificados mediante la autoridad certificadora de Microsoft a trav&eacute;s de MSCEWS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-OpenXPKI-CA-group.html#d0e7680" title="Administraci&oacute;n de certificados mediante la autoridad certificadora de OpenXPKI a trav&eacute;s de SCEP">
      Administraci&oacute;n de certificados mediante la autoridad certificadora de OpenXPKI a trav&eacute;s de SCEP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-EST-group.html#d0e8747" title="Administraci&oacute;n de certificados mediante la autoridad certificadora de OpenXPKI a trav&eacute;s de EST">
      Administraci&oacute;n de certificados mediante la autoridad certificadora de OpenXPKI a trav&eacute;s de EST
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-device-alerts-chapter.html#managing-device-alerts-chapter_es" title="Administraci&oacute;n de alertas de impresora">
     Administraci&oacute;n de alertas de impresora
    </a>
   </p>
   <div id="divd0e9833">
    <p class="toc-2-style">
     <a href="managing-printer-alerts-overview-topic.html#managing-printer-alerts-overview_es" title="Descripci&oacute;n general">
      Descripci&oacute;n general
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-action-topic.html#creating-action_es" title="Creaci&oacute;n de una acci&oacute;n">
      Creaci&oacute;n de una acci&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-action-placeholders-topic.html#understanding-action-placeholders_es" title="Descripci&oacute;n de los marcadores de posici&oacute;n de acci&oacute;n">
      Descripci&oacute;n de los marcadores de posici&oacute;n de acci&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-actions-topic.html#managing-actions_es" title="Administraci&oacute;n de acciones">
      Administraci&oacute;n de acciones
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-event-topic.html#creating-event_es" title="Creaci&oacute;n de un evento">
      Creaci&oacute;n de un evento
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-printer-alerts-topic.html#understanding-printer-alerts_es" title="Descripci&oacute;n de las alertas de impresora">
      Descripci&oacute;n de las alertas de impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-events-topic.html#managing-events_es" title="Administraci&oacute;n de eventos">
      Administraci&oacute;n de eventos
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="viewing-tasks-chapter.html#viewing-tasks-chapter_es" title="Visualizaci&oacute;n del estado y el historial de las tareas">
     Visualizaci&oacute;n del estado y el historial de las tareas
    </a>
   </p>
   <div id="divd0e10465">
    <p class="toc-2-style">
     <a href="viewing-task-status-history-overview-topic.html#viewing-task-status-history-overview_es" title="Descripci&oacute;n general">
      Descripci&oacute;n general
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-task-status-topic.html#viewing-task-status_es" title="Visualizaci&oacute;n del estado de la tarea">
      Visualizaci&oacute;n del estado de la tarea
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stopping-tasks-topic.html#stopping-tasks_es" title="Detenci&oacute;n de tareas">
      Detenci&oacute;n de tareas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-logs-topic.html#viewing-logs_es" title="Visualizaci&oacute;n de archivos de registro">
      Visualizaci&oacute;n de archivos de registro
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-logs-topic.html#clearing-logs_es" title="Borrado de registros">
      Borrado de registros
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-logs-topic.html#exporting-logs_es" title="Exportaci&oacute;n de registros">
      Exportaci&oacute;n de registros
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="scheduling-tasks.html#scheduling-tasks_es" title="Programaci&oacute;n de tareas">
     Programaci&oacute;n de tareas
    </a>
   </p>
   <div id="divd0e10573">
    <p class="toc-2-style">
     <a href="creating-schedule-topic.html#creating-schedule_es" title="Creaci&oacute;n de un programa">
      Creaci&oacute;n de un programa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-schedules-topic.html#managing-schedules_es" title="Administraci&oacute;n de tareas programadas">
      Administraci&oacute;n de tareas programadas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="admin-tasks-chapter.html#admin-tasks-chapter_es" title="Realizaci&oacute;n de otras tareas administrativas">
     Realizaci&oacute;n de otras tareas administrativas
    </a>
   </p>
   <div id="divd0e10715">
    <p class="toc-2-style">
     <a href="configuring-system-settings-topic.html#configuring-system-settings_es" title="Configuraci&oacute;n de los valores generales">
      Configuraci&oacute;n de los valores generales
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-email-settings-topic.html#configuring-email-settings_es" title="Configuraci&oacute;n de los valores del correo electr&oacute;nico">
      Configuraci&oacute;n de los valores del correo electr&oacute;nico
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-login-disclaimer-topic.html#adding-login-disclaimer_es" title="Adici&oacute;n de una renuncia de responsabilidad de inicio de sesi&oacute;n">
      Adici&oacute;n de una renuncia de responsabilidad de inicio de sesi&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="signing-mve-certificate-topic.html#signing-mve-certificate_es" title="Firma del certificado MVE">
      Firma del certificado MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-user-information-topic.html#removing-user-information_es" title="Eliminaci&oacute;n de la informaci&oacute;n de usuario y las referencias a este">
      Eliminaci&oacute;n de la informaci&oacute;n de usuario y las referencias a este
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-SSO-chapter.html#managing-SSO-chapter_es" title="Gesti&oacute;n de SSO">
     Gesti&oacute;n de SSO
    </a>
   </p>
   <div id="divd0e10973">
    <p class="toc-2-style">
     <a href="mve-configuration-workflow-adfs-overview-topic.html#d0e10978" title="Descripci&oacute;n general">
      Descripci&oacute;n general
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-claim-issuance-policy-grouprule-topic.html#setting-claim-issuance-policy-grouprule_es" title="Configuraci&oacute;n de la pol&iacute;tica de emisi&oacute;n de reclamaciones para GroupRule">
      Configuraci&oacute;n de la pol&iacute;tica de emisi&oacute;n de reclamaciones para GroupRule
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-claim-issuance-policy-name-id-topic.html#setting-claim-issuance-policy-name-id_es" title="Configuraci&oacute;n de la pol&iacute;tica de emisi&oacute;n de reclamaciones para el ID de nombre">
      Configuraci&oacute;n de la pol&iacute;tica de emisi&oacute;n de reclamaciones para el ID de nombre
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-adfs-server-authentication-topic.html#enabling-adfs-server-authentication_es" title="Activaci&oacute;n de la autenticaci&oacute;n del servidor ADFS">
      Activaci&oacute;n de la autenticaci&oacute;n del servidor ADFS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-mve-adfs-topic.html#accessing-mve-adfs_es" title="Acceso a MVE mediante ADFS">
      Acceso a MVE mediante ADFS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="logging-out-mve-adfs-topic.html#logging-out-mve-adfs_es" title="Cerrar sesi&oacute;n en MVE">
      Cerrar sesi&oacute;n en MVE
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faq-chapter.html#faq-chapter_es" title="Preguntas m&aacute;s frecuentes">
     Preguntas m&aacute;s frecuentes
    </a>
   </p>
   <div id="divd0e11143">
    <p class="toc-2-style">
     <a href="faq-chapter.html#frequently-asked-questions_es" title="Preguntas m&aacute;s frecuentes sobre Markvision Enterprise">
      Preguntas m&aacute;s frecuentes sobre Markvision Enterprise
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_es" title="Soluci&oacute;n de problemas">
     Soluci&oacute;n de problemas
    </a>
   </p>
   <div id="divd0e11337">
    <p class="toc-2-style">
     <a href="trb-forgotten-password-mve-topic.html#trb-forgotten-password-mve_es" title="El usuario ha olvidado la contrase&ntilde;a">
      El usuario ha olvidado la contrase&ntilde;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-admin-forgotten-password-mve-topic.html#trb-admin-forgotten-password-mve_es" title="El usuario administrador ha olvidado la contrase&ntilde;a">
      El usuario administrador ha olvidado la contrase&ntilde;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-page-loading-infinitely-topic.html#trb-page-loading-infinitely_es" title="La p&aacute;gina no se carga">
      La p&aacute;gina no se carga
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-discover-network-device-topic.html#trb-cannot-discover-network-device_es" title="No se puede encontrar una impresora de red">
      No se puede encontrar una impresora de red
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-incorrect-device-information-topic.html#trb-incorrect-device-information_es" title="Informaci&oacute;n de la impresora incorrecta">
      Informaci&oacute;n de la impresora incorrecta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-mve-does-not-recognize-secured-printer-topic.html#trb-mve-does-not-recognize-secured-printer_es" title="MVE no reconoce una impresora como protegida">
      MVE no reconoce una impresora como protegida
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-config-enforcement-fails-topic.html#trb-config-enforcement-fails_es" title="El uso de las configuraciones con varias aplicaciones genera un error en el primer intento, pero no se producen problemas en los intentos posteriores">
      El uso de las configuraciones con varias aplicaciones genera un error en el primer intento, pero no se producen problemas en los intentos posteriores
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-enforcement-printer-cert-fails-topic.html#trb-enforcement-printer-cert-fails_es" title="Aplicaci&oacute;n de configuraciones si falla la emisi&oacute;n del certificado de la impresora">
      Aplicaci&oacute;n de configuraciones si falla la emisi&oacute;n del certificado de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-openxpki-ca-group.html#d0e11554" title="Autoridad certificadora de OpenXPKI">
      Autoridad certificadora de OpenXPKI
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="database-access-chapter.html#database-access-chapter_es" title="Acceso a la base de datos">
     Acceso a la base de datos
    </a>
   </p>
   <div id="divd0e11724">
    <p class="toc-2-style">
     <a href="differences-supported-databases-data-types-topic.html#differences-supported-databases-data-types_es" title="Diferencias en los tipos de datos de bases de datos compatibles">
      Diferencias en los tipos de datos de bases de datos compatibles
     </a>
    </p>
    <p class="toc-2-style">
     <a href="config-item-topic.html#d0e11785" title="Tablas FRAMEWORK y nombres de campo">
      Tablas FRAMEWORK y nombres de campo
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="appendix-chapter.html#appendix-chapter_es" title="Ap&eacute;ndice">
     Ap&eacute;ndice
    </a>
   </p>
   <div id="divd0e17725">
    <p class="toc-2-style">
     <a href="understanding-ports-and-protocols-topic.html#understanding-ports-and-protocols_es" title="Descripci&oacute;n de puertos y protocolos">
      Descripci&oacute;n de puertos y protocolos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html#enabling-automatic-approval-certificate-requests-microsoft-ca_es" title="Activaci&oacute;n de la aprobaci&oacute;n autom&aacute;tica de solicitudes de certificado en la CA de Microsoft">
      Activaci&oacute;n de la aprobaci&oacute;n autom&aacute;tica de solicitudes de certificado en la CA de Microsoft
     </a>
    </p>
    <p class="toc-2-style">
     <a href="revoking-certificates-topic.html#revoking-certificates_es" title="Revocaci&oacute;n de certificados">
      Revocaci&oacute;n de certificados
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="leap_notices.html#leap_notices_es" title="Avisos">
     Avisos
    </a>
   </p>
   <div id="divd0e18101">
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e18104" title="Nota sobre la edici&oacute;n">
      Nota sobre la edici&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e18140" title="Marcas comerciales">
      Marcas comerciales
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#us-government-rights_es" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#jmdns-license_es" title="JmDNS License">
      JmDNS License
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#licensing-notices-program-folder_es" title="Avisos de licencia">
      Avisos de licencia
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="glossary.html#glossary_es" title="Glosario">
     Glosario
    </a>
   </p>
   <div id="divd0e18170">
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue